/* eslint-disable max-len */
import React from 'react';

function MedicalInsuranceIcon({
  width = 24,
  height = 24,
  ...rest
}: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 -1 24 26"
      version="1.1"
      {...rest}>
      <g id="surface1">
        <path
          strokeWidth={1.5}
          fillRule="nonzero"
          stroke="currentColor"
          fill="transparent"
          d="M 1.59375 3.28125 C 1.59375 5.875 1.375 8.585938 1.753906 11.15625 C 2.304688 14.871094 4.144531 18.191406 6.84375 20.765625 C 7.910156 21.785156 9.128906 22.550781 10.40625 23.269531 C 10.816406 23.503906 11.519531 23.988281 12 23.988281 C 12.480469 23.988281 13.183594 23.503906 13.59375 23.269531 C 14.871094 22.550781 16.089844 21.785156 17.15625 20.765625 C 19.847656 18.199219 21.75 14.828125 22.253906 11.109375 C 22.597656 8.542969 22.40625 5.871094 22.40625 3.28125 C 19.863281 3.28125 17.558594 3.222656 15.1875 2.183594 C 14.367188 1.824219 13.582031 1.285156 12.890625 0.722656 C 12.679688 0.550781 12.28125 0.03125 12 0.03125 C 11.71875 0.03125 11.320312 0.550781 11.109375 0.722656 C 10.417969 1.285156 9.632812 1.824219 8.8125 2.183594 C 6.441406 3.222656 4.136719 3.28125 1.59375 3.28125 Z M 1.59375 3.28125 "
        />
        <path
          strokeWidth={1.5}
          fillRule="nonzero"
          fill="currentColor"
          d="M 9.84375 7.40625 L 9.84375 9.84375 L 7.40625 9.84375 L 7.40625 14.15625 L 9.84375 14.15625 L 9.84375 16.59375 L 14.15625 16.59375 L 14.15625 14.15625 L 16.59375 14.15625 L 16.59375 9.84375 L 14.15625 9.84375 L 14.15625 7.40625 Z M 9.84375 7.40625 "
        />
        <path
          strokeWidth={1.5}
          fillRule="nonzero"
          fill="#ffffff"
          d="M 11.296875 8.859375 L 11.296875 11.296875 L 8.859375 11.296875 L 8.859375 12.703125 L 11.296875 12.703125 L 11.296875 15.140625 L 12.703125 15.140625 L 12.703125 12.703125 L 15.140625 12.703125 L 15.140625 11.296875 L 12.703125 11.296875 L 12.703125 8.859375 Z M 11.296875 8.859375 "
        />
      </g>
    </svg>
  );
}

export default MedicalInsuranceIcon;
